<template>
	<div class="page-logout">
		<div class="container">
			<div class="is-loading large dark"></div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getAxiosErrorMessage } from '@/lib/helper';
import authApi from '@/api/auth';

export default {
	name: 'Logout',
	data() {
		return {
		};
	},
	methods: {
		...mapActions({
			logout: 'logout',
		}),
		updateTemplateSettings() {
			const settings = JSON.parse(this.user.settings);
			settings.last_category_template = '';
			settings.last_keyword_template = '';
			const paramsSettings = { settings: JSON.stringify(settings) };
			const callback = () => {
				this.logout();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t('Update Profile'),
					text: message,
				});
			};
			authApi.updateProfile(paramsSettings, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
	},
	created() {
		this.updateTemplateSettings();
	},
};
</script>
